// extracted by mini-css-extract-plugin
export default {"h":"style_h__WRExP"};